import { useState, useRef } from "react";
import style from "./TooltipTemplate.module.scss";
import eyesIcon from "assets/images/eyes-icon.svg";
import templateIcon from "assets/images/template-icon.svg";
import { DynamicTooltip } from "../DynamicTooltip/DynamicTooltip";

export const TooltipTemplate = ({ data }) => {
  const ref = useRef(null);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const showTooltip = () => setIsTooltipVisible(true);
  const hideTooltip = () => setIsTooltipVisible(false);

  const renderType = type => {
    switch (type) {
      case "PRODUCT":
        return "Producto";
      case "BOX":
        return "Caja";
      case "PALLET":
        return "Embalaje";
      default:
        return "";
    }
  };

  return (
    <>
      <img
        src={eyesIcon}
        draggable={false}
        ref={ref}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        className={style.icon}
      />
      <DynamicTooltip isTooltipVisible={isTooltipVisible} targetRef={ref}>
        <article className={style.content}>
          <header>
            <div>
              <picture>
                <img src={templateIcon} draggable={false} />
              </picture>
              <div>
                <h4>Nombre</h4>
                <h3>{data?.name}</h3>
              </div>
            </div>
            <span>{renderType(data?.type)}</span>
          </header>
          <section>
            <ul>
              <li>
                <span>DESCRPCIÓN</span>
                <p>{data?.description || "-"}</p>
              </li>
              <li>
                <span>DIMENSIONES</span>
                <p>
                  Alto {data?.height}mm Ancho {data?.width}mm
                </p>
              </li>
              <li>
                <span>MEMORIA EPC</span>
                <p>{data?.mem_epc}GB</p>
              </li>
              <li>
                <span>MEMORIA USUARIOS</span>
                <p>{data?.mem_user}GB</p>
              </li>
            </ul>
          </section>
        </article>
      </DynamicTooltip>
    </>
  );
};